"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _index = _interopRequireDefault(require("../components/mobileFormPage/index.js"));
var _index2 = _interopRequireDefault(require("../components/mobileFormConfig/index.js"));
var _vuex = require("vuex");
var _useDevise = _interopRequireDefault(require("@/hooks/use-devise"));
var _systemForm = require("@/api/systemForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _useDeviseDiy = (0, _useDevise.default)(),
  objToArr = _useDeviseDiy.objToArr;
var idGlobal = 0;
var _default = exports.default = {
  name: 'creatSystemFrom',
  components: _objectSpread(_objectSpread({
    draggable: _vuedraggable.default
  }, _index.default), _index2.default),
  data: function data() {
    return {
      objval: {},
      leftMenu: [],
      // 左侧菜单
      lConfig: [],
      // 左侧组件
      mConfig: [],
      // 中间组件渲染
      rConfig: [],
      // 右侧组件配置
      clientHeight: '',
      //页面动态高度
      nameTopFrom: '',
      //头部模板名称表单提交
      visible: false,
      rollHeight: '',
      activeConfigName: '',
      propsObj: {},
      // 组件传递的数据,
      activeIndex: 0,
      // 选中的下标
      number: 0,
      pageId: '',
      pageType: '',
      tabCur: 0,
      loading: false,
      relLoading: false,
      isSearch: false,
      isTab: false,
      isFllow: false,
      isComb: false,
      isService: false,
      name: '' //模板名称
    };
  },
  watch: {
    nameTop: function nameTop(val) {
      //直接赋值给本地data中的属性，就不会报错啦
      this.name = val;
    }
  },
  computed: _objectSpread({}, (0, _vuex.mapState)({
    nameTop: function nameTop(state) {
      return state.mobildConfig.pageName || '系统表单';
    },
    showTxt: function showTxt(state) {
      return state.mobildConfig.pageShow;
    },
    colorTxt: function colorTxt(state) {
      return state.mobildConfig.pageColor;
    },
    picTxt: function picTxt(state) {
      return state.mobildConfig.pagePic;
    },
    colorPickerTxt: function colorPickerTxt(state) {
      return state.mobildConfig.pageColorPicker;
    },
    tabValTxt: function tabValTxt(state) {
      return state.mobildConfig.pageTabVal;
    },
    picUrlTxt: function picUrlTxt(state) {
      return state.mobildConfig.pagePicUrl;
    }
  })),
  created: function created() {
    this.lConfig = objToArr(_index.default);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('mobildConfig/titleUpdata', '');
    this.$store.commit('mobildConfig/nameUpdata', '');
    this.$store.commit('mobildConfig/showUpdata', 1);
    this.$store.commit('mobildConfig/colorUpdata', 0);
    this.$store.commit('mobildConfig/picUpdata', 0);
    this.$store.commit('mobildConfig/pickerUpdata', '#f5f5f5');
    this.$store.commit('mobildConfig/radioUpdata', 0);
    this.$store.commit('mobildConfig/picurlUpdata', '');
    this.$store.commit('mobildConfig/SETEMPTY');
  },
  destroyed: function destroyed() {
    this.$store.commit('mobildConfig/titleUpdata', '');
    this.$store.commit('mobildConfig/nameUpdata', '');
    this.$store.commit('mobildConfig/showUpdata', 1);
    this.$store.commit('mobildConfig/colorUpdata', 0);
    this.$store.commit('mobildConfig/picUpdata', 0);
    this.$store.commit('mobildConfig/pickerUpdata', '#f5f5f5');
    this.$store.commit('mobildConfig/radioUpdata', 0);
    this.$store.commit('mobildConfig/picurlUpdata', '');
    this.$store.commit('mobildConfig/SETEMPTY');
  },
  mounted: function mounted() {
    var _this = this;
    //监听事件
    document.addEventListener('keydown', this.saveDiy, {
      passive: true
    });
    this.pageId = Number(this.$route.params.id);
    this.pageType = this.$route.params.type;
    if (this.pageId === 0) this.visible = true; //新增的时候修改模板名称显示出来
    this.nameTopFrom = this.pageType !== 'copy' ? this.nameTop : this.nameTop + '-副本';
    this.name = this.pageType !== 'copy' ? this.nameTop : this.nameTop + '-副本';
    this.$nextTick(function () {
      _this.arraySort();
      if (_this.pageId != 0) {
        _this.getDefaultConfig();
      }
      _this.clientHeight = "".concat(document.documentElement.clientHeight) - 65.81; //获取浏览器可视区域高度
      var H = "".concat(document.documentElement.clientHeight) - 180;
      _this.rollHeight = H > 650 ? 650 : H;
      var that = _this;
      window.onresize = function () {
        that.clientHeight = "".concat(document.documentElement.clientHeight) - 65.81;
        var H = "".concat(document.documentElement.clientHeight) - 180;
        that.rollHeight = H > 650 ? 650 : H;
      };
    });
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: "".concat(roterPre, "/systemForm/form_list")
      });
    },
    onMove: function onMove(e) {
      return true;
    },
    onCopy: function onCopy() {
      this.$message.success('复制成功');
    },
    onError: function onError() {
      this.$message.error('复制失败');
    },
    // 左侧tab
    bindTab: function bindTab(index) {
      this.tabCur = index;
    },
    log: function log(evt) {
      // 中间拖拽排序
      if (evt.moved) {
        evt.moved.oldNum = this.mConfig[evt.moved.oldIndex].num;
        evt.moved.newNum = this.mConfig[evt.moved.newIndex].num;
        evt.moved.status = evt.moved.oldIndex > evt.moved.newIndex;
        this.mConfig.forEach(function (el, index) {
          el.num = new Date().getTime() * 1000 + index;
        });
        evt.moved.list = this.mConfig;
        this.rConfig = [];
        var item = evt.moved.element;
        var tempItem = JSON.parse(JSON.stringify(item));
        this.rConfig.push(tempItem);
        this.activeIndex = evt.moved.newIndex;
        //  this.$store.commit('mobildConfig/SETCONFIGNAME', item.name);
        this.$store.commit('mobildConfig/defaultArraySort', evt.moved);
      }
      // 从左向右拖拽排序
      if (evt.added) {
        var data = evt.added.element;
        var obj = {};
        var timestamp = new Date().getTime() * 1000;
        data.num = timestamp;
        this.activeConfigName = data.name;
        var _tempItem = JSON.parse(JSON.stringify(data));
        _tempItem.id = 'id' + _tempItem.num;
        this.mConfig[evt.added.newIndex] = _tempItem;
        this.rConfig = [];
        this.rConfig.push(_tempItem);
        this.mConfig.forEach(function (el, index) {
          el.num = new Date().getTime() * 1000 + index;
        });
        evt.added.list = this.mConfig;
        this.activeIndex = evt.added.newIndex;
        // 保存组件名称
        //  this.$store.commit('mobildConfig/SETCONFIGNAME', data.name);
        this.$store.commit('mobildConfig/defaultArraySort', evt.added);
      }
    },
    cloneDog: function cloneDog(data) {
      // this.mConfig.push(tempItem)
      return _objectSpread({}, data);
    },
    //数组元素互换位置
    swapArray: function swapArray(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    //点击上下移动；
    movePage: function movePage(item, index, type) {
      if (type) {
        if (index == 0) {
          return;
        }
      } else {
        if (index == this.mConfig.length - 1) {
          return;
        }
      }
      if (type) {
        this.swapArray(this.mConfig, index - 1, index);
      } else {
        this.swapArray(this.mConfig, index, index + 1);
      }
      var obj = {};
      this.rConfig = [];
      obj.oldIndex = index;
      if (type) {
        obj.newIndex = index - 1;
      } else {
        obj.newIndex = index + 1;
      }
      this.mConfig.forEach(function (el, index) {
        el.num = new Date().getTime() * 1000 + index;
      });
      var tempItem = JSON.parse(JSON.stringify(item));
      this.rConfig.push(tempItem);
      obj.element = item;
      obj.list = this.mConfig;
      if (type) {
        this.activeIndex = index - 1;
      } else {
        this.activeIndex = index + 1;
      }
      this.$store.commit('mobildConfig/SETCONFIGNAME', item.name);
      this.$store.commit('mobildConfig/defaultArraySort', obj);
    },
    // 组件添加
    addDomCon: function addDomCon(item, type, index) {
      idGlobal += 1;
      var obj = {};
      var timestamp = new Date().getTime() * 1000;
      item.num = "".concat(timestamp);
      item.id = "id".concat(timestamp);
      this.activeConfigName = item.name;
      var tempItem = JSON.parse(JSON.stringify(item));
      if (type) {
        this.rConfig = [];
        this.mConfig.push(tempItem);
        this.activeIndex = this.mConfig.length - 1;
        this.rConfig.push(tempItem);
      } else {
        this.mConfig.splice(index + 1, 0, tempItem);
        this.activeIndex = index;
      }
      this.mConfig.forEach(function (el, index) {
        el.num = new Date().getTime() * 1000 + index;
      });
      // 保存组件名称
      obj.element = item;
      obj.list = this.mConfig;
      // this.$store.commit('mobildConfig/SETCONFIGNAME', item.name);
      this.$store.commit('mobildConfig/defaultArraySort', obj);
    },
    //中间页点击添加模块；
    bindAddDom: function bindAddDom(item, type, index) {
      var i = item;
      this.lConfig.forEach(function (j) {
        if (item.name == j.name) {
          i = j;
        }
      });
      this.addDomCon(i, type, index);
    },
    //左边配置模块点击添加；
    addDom: function addDom(item, type) {
      this.addDomCon(item, type);
    },
    // 点击显示相应的配置
    bindconfig: function bindconfig(item, index) {
      this.rConfig = [];
      var tempItem = JSON.parse(JSON.stringify(item));
      this.rConfig.push(tempItem);
      this.activeIndex = index;
      //  this.$store.commit('mobildConfig/SETCONFIGNAME', item.name);
    },
    // 组件删除
    bindDelete: function bindDelete(item, key) {
      this.mConfig.splice(key, 1);
      this.rConfig.splice(0, 1);
      if (this.mConfig.length != key) {
        this.rConfig.push(this.mConfig[key]);
      } else {
        if (this.mConfig.length) {
          this.activeIndex = key - 1;
          this.rConfig.push(this.mConfig[key - 1]);
        }
      }
      // 删除第几个配置
      this.$store.commit('mobildConfig/DELETEARRAY', item);
    },
    // 组件返回
    config: function config(data) {
      var propsObj = this.propsObj;
      propsObj.data = data;
      propsObj.name = this.activeConfigName;
    },
    addSort: function addSort(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    // 数组排序
    arraySort: function arraySort() {
      var tempArr = [];
      var basis = {
        title: '组件',
        list: [],
        isOpen: true
      };
      this.lConfig.map(function (el, index) {
        if (el.type == 0) {
          basis.list.push(el);
        }
      });
      tempArr.push(basis);
      this.leftMenu = tempArr;
    },
    diySaveDate: function diySaveDate(val, n, j) {
      var _this2 = this;
      var data = [];
      objToArr(val).forEach(function (item) {
        data.push(item.titleConfig.val);
      });
      this.pageId ? (0, _systemForm.systemFormUpdateApi)({
        id: this.pageId,
        allKeys: data.join(','),
        formValue: JSON.stringify(val),
        formName: this.nameTopFrom
      }).then(function (res) {
        _this2.$message.success('保存成功');
        _this2.$store.commit('mobildConfig/SET_SystemForm', []);
        _this2.loading = false;
        _this2.relLoading = false;
        _this2.close(n);
      }).catch(function (res) {
        _this2.loading = false;
        _this2.$message.error(res.message);
      }) : (0, _systemForm.systemFormAddApi)({
        allKeys: data.join(','),
        formValue: JSON.stringify(val),
        formName: this.nameTopFrom
      }).then(function (res) {
        _this2.pageId = res.id;
        _this2.$message.success('保存成功');
        _this2.loading = false;
        _this2.$store.commit('mobildConfig/SET_SystemForm', []);
        _this2.$store.commit('mobildConfig/nameUpdata', _this2.nameTopFrom);
        _this2.close(n);
      }).catch(function (res) {
        _this2.loading = false;
        _this2.relLoading = false;
        _this2.$message.error(res.message);
      });
    },
    //保存关闭
    close: function close(n) {
      this.$store.commit('mobildConfig/UPNAME', this.nameTopFrom);
      if (n === 1) {
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf('Firefox') != -1 || userAgent.indexOf('Chrome') != -1) {
          window.open('', '_self').close();
          window.location.href = 'about:blank';
        } else {
          window.opener = null;
          window.open('about:blank', '_self');
          window.close();
        }
      }
    },
    // 模板名称保存
    saveName: function saveName(n, j) {
      if (!n) return this.$message.warning('请填写模板名称');
      if (j === 1) {
        //this.$store.commit('mobildConfig/UPNAME', this.nameContent);
      } else {
        this.$store.commit('mobildConfig/UPNAME', this.nameTopFrom);
      }
    },
    /**
     * 保存配置
     * @param n 是否关闭页面，1是
     * @param j 是否是另存模板，1是,0只编辑模板名称
     */
    saveConfig: function saveConfig(n, j) {
      if (this.mConfig.length == 0) {
        return this.$message.error('暂未添加任何组件，保存失败！');
      }
      this.loading = true;
      var val = this.$store.state.mobildConfig.defaultArray;
      this.$nextTick(function () {
        this.diySaveDate(val, n, j);
      });
    },
    // 获取默认配置
    getDefaultConfig: function getDefaultConfig() {
      var _this3 = this;
      (0, _systemForm.systemFormDetailApi)(this.pageId).then(function (res) {
        _this3.nameTopFrom = _this3.pageType !== 'copy' ? res.formName : res.formName + '-副本';
        _this3.$store.commit('mobildConfig/nameUpdata', _this3.pageType !== 'copy' ? res.formName : res.formName + '-副本');
        var obj = {};
        var tempARR = [];
        var newArr = objToArr(JSON.parse(res.formValue));
        function sortNumber(a, b) {
          return a.timestamp - b.timestamp;
        }
        newArr.sort(sortNumber);
        newArr.map(function (el, index) {
          el.id = 'id' + el.timestamp;
          _this3.lConfig.map(function (item, j) {
            if (el.name == item.defaultName) {
              item.num = el.timestamp;
              item.id = 'id' + el.timestamp;
              var tempItem = JSON.parse(JSON.stringify(item));
              tempARR.push(tempItem);
              obj[el.timestamp] = el;
              _this3.mConfig.push(tempItem);
              // 保存默认组件配置
              _this3.$store.commit('mobildConfig/ADDARRAY', {
                num: el.timestamp,
                val: el
              });
            }
          });
        });
        _this3.rConfig = [];
        _this3.activeIndex = 0;
        _this3.rConfig.push(_this3.mConfig[0]);
      });
    },
    // 重置
    reast: function reast() {
      var _this4 = this;
      this.$modalSure('是否重置当前页面数据?').then(function () {
        _this4.mConfig = [];
        _this4.rConfig = [];
        _this4.activeIndex = -99;
        _this4.$store.commit('mobildConfig/SETEMPTY');
        if (_this4.pageId) _this4.getDefaultConfig();
      });
    }
  }
};